<template>
    <div>
        <common-table :table-columns="tableColumns"
                      :url="url"
                      :operate="[]"
                      :form-fields="formFields"
                      :permission="permission"
                      :searchs="searches"
                      ref="table"/>
    </div>
</template>

<script>
    import CommonTable from "../../components/CommonTable/CommonTable";
    export default {
        name: "SiteSetting",
        components: {CommonTable},
        data() {
            return {
                searches: [{
                    name: 'agentId',
                    placeholder: '代理',
                    type: 'select',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                }],
                permission:{
                    add: 'siteSetting:add',
                    update: 'siteSetting:update',
                    delete: 'siteSetting:delete',
                    deleteBatch: 'siteSetting:deleteBatch'
                },
                url: {
                    get: '/siteSetting/listByCondition',
                    add: '/siteSetting/add',
                    update: '/siteSetting/update',
                    delete: '/siteSetting/delete/',
                    delete_batch: '/siteSetting/deleteBatch',
                    status: '/siteSetting/status',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '',
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select'
                    },
                    detail: false,
                    width: '',
                }, {
                    field: 'registerReward',
                    label: '注册奖励',
                    show: true,
                    width: '',
                }, {
                    field: 'level1Reward',
                    label: '一级奖励',
                    show: true,
                    width: '',
                }, {
                    field: 'level2Reward',
                    label: '二级奖励',
                    show: true,
                    width: '',
                }, {
                    field: 'level3Reward',
                    label: '三级奖励',
                    show: true,
                    width: '',
                }, {
                    field: 'minRecharge',
                    label: '最低充值',
                    show: true,
                    width: '',
                }, {
                    field: 'loginVerify',
                    label: '是否开启登录验证码',
                    show: true,
                    status: true,
                    width: '',
                }, {
                    field: 'locationVerify',
                    label: '是否开启提现地区验证',
                    show: true,
                    status: true,
                    width: '',
                }, {
                  field: 'sameIpRegister',
                  label: '同ip注册',
                  show: true,
                  status: true,
                  width: '',
                }, {
                  field: 'isLimit',
                  label: '是否开启量化限制',
                  show: true,
                  status: true,
                  width: '',
                },{
                    field: 'createTime',
                    label: '时间',
                    show: true,
                    width: '',
                }],
                formFields: {
                    addTitle: '添加代理配置',
                    updateTitle: '修改代理配置',
                    labelWidth: '90px',
                    model: [{
                        field: 'agentId',
                        label: '代理',
                        type: 'select',
                        selectUrl: '/agent/getAll',
                        selectData: [],
                        placeholder: '请选择',
                        rules: [{
                            message: '请选择代理', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }, {
                        field: 'registerReward',
                        label: '注册奖励',
                        type: 'input',
                        placeholder: '注册奖励(USDT)',
                        rules:[{
                            message: '请输入注册奖励', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }, {
                        field: 'level1Reward',
                        label: '一级奖励',
                        type: 'input',
                        placeholder: '一级奖励(USDT)',
                        rules:[{
                            message: '请输入一级奖励', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }, {
                        field: 'level2Reward',
                        label: '二级奖励',
                        type: 'input',
                        placeholder: '二级奖励(USDT)',
                        rules:[{
                            message: '请输入二级奖励', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }, {
                        field: 'level3Reward',
                        label: '三级奖励',
                        type: 'input',
                        placeholder: '三级奖励(USDT)',
                        rules:[{
                            message: '请输入三级奖励', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }, {
                        field: 'minRecharge',
                        label: '最低充值',
                        type: 'input',
                        placeholder: '最低充值(USDT)',
                        rules:[{
                            message: '请输入最低充值', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }]
                }
            }
        }
    }
</script>

<style scoped>

</style>
